export const SET_LOADING_DATA = '@clientReportChecklist/SET_LOADING_DATA';
export const SET_LOADING_SELECTS = '@clientReportChecklist/SET_LOADING_SELECTS';

export const GET_LIST_ALL_CHECKLIST_REPORTS_REQUEST = '@clientReportChecklist/GET_LIST_ALL_CHECKLIST_REPORTS_REQUEST';
export const GET_LIST_ALL_CHECKLIST_REPORTS_SUCCESS = '@clientReportChecklist/GET_LIST_ALL_CHECKLIST_REPORTS_SUCCESS';

export const GET_MODAL_QUESTIONS_REQUEST = '@clientReportChecklist/GET_MODAL_QUESTIONS_REQUEST';
export const GET_MODAL_QUESTIONS_SUCCESS = '@clientReportChecklist/GET_MODAL_QUESTIONS_SUCCESS';

export const GET_ALL_SELECTS_REQUEST = '@clientReportChecklist/GET_ALL_SELECTS_REQUEST';
export const GET_ALL_SELECTS_SUCCESS = '@clientReportChecklist/GET_ALL_SELECTS_SUCCESS';

export const SHARE_CSV = '@clientReportChecklist/SHARE_CSV';

export const SET_PAGE = '@clientReportChecklist/SET_PAGE';
export const SET_ROWS_COUNT = '@clientReportChecklist/SET_ROWS_COUNT';
export const SET_ROWS_PER_PAGE = '@clientReportChecklist/SET_ROWS_PER_PAGE';
export const SET_ORDER = '@clientReportChecklist/SET_ORDER';
export const SET_ORDERBY = '@clientReportChecklist/SET_ORDERBY';

export const SEARCH = '@clientReportChecklist/SEARCH';
